import { render, staticRenderFns } from "./complaint-room.vue?vue&type=template&id=8ad694b4&scoped=true&"
import script from "./complaint-room.vue?vue&type=script&setup=true&lang=js&"
export * from "./complaint-room.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./complaint-room.vue?vue&type=style&index=0&id=8ad694b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.2_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.105.4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad694b4",
  null
  
)

export default component.exports